import React from 'react'
import { TripleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import WhitepapersTab from '../../components/WhitepapersTab'
import Navbar from '../../components/Navbar'
import { useTranslation } from 'react-i18next'
import banking_whitepaper from "../../assets/images/contents/banking-whitepaper.png"
import info_graphic from "../../assets/images/contents/info-graphic.png"
import Footer from '../../components/Footer'
import { StyledLink } from '../../components/StyledComponents'
import filter_color from "../../assets/images/design/colorFilter.svg"

const BankingWhitepaper = () => {
  const { t } = useTranslation()

  return (
    <div className='whitepapers bg-primary'>
      <div className='color-filter-left' style={{ left: "10%" }} >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <div className='color-filter-left' style={{ top: "25%" }} >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <Navbar />
      <div className='container-fluid insurance-header pb-100'>
        <div className='container'>
          <div className='col-sm-10 col-sm-offset-1 pt-150'>
            <div className='font-weight-bold text-center font-64 insurance-header-title'>{t('whitepapers-tab.banking-whitepaper')}</div>
            <div className='col-sm-12'>
              <div className='underline-orange'></div>
            </div>
          </div>
          <div className='col-sm-12 flex justify-center pt-md-100 pt-50 px-0'>
            <TripleCustomBreadCrumbs prevPage={t('bread-crumbs.whitepapers')} currentPage={t('bread-crumbs.banking-whitepaper')} linkToPrevPage="/whitepapers" />
          </div>
        </div>
      </div>
      <WhitepapersTab bankingActive={true} />
      <div className="whitepapers-content container pb-100">
        <div className='row'>
          <div className='col-lg-4'>

            <div className="whitepapers-card-mini">
              <StyledLink href="/whitepapers/banking">
                <div className='whitepapers-card-mini_image'>
                  <img src={banking_whitepaper} alt="" className='img-responsive' />
                </div>
              </StyledLink>
              <div className='case-study-chip mt-20'>
                {t('whitepapers-tab.banking-whitepaper')}
              </div>
              <StyledLink href="/whitepapers/banking">
                <p className='pt-20 text-white font-20 font-weight-semi-bold'>{t('whitepapers-tab.banking-whitepaper')}</p>
              </StyledLink>
            </div>

          </div>
          <div className='col-lg-4'>

            <div className="whitepapers-card-mini">
              <StyledLink href="/whitepapers/infographic-on-bank-fraud">
                <div className='whitepapers-card-mini_image'>
                  <img src={info_graphic} alt="" className='img-responsive' />
                </div>
              </StyledLink>
              <div className='case-study-chip mt-20'>
                {t('whitepapers-tab.banking-whitepaper')}
              </div>
              <StyledLink href="/whitepapers/infographic-on-bank-fraud">
                <p className='pt-20 text-white font-20 font-weight-semi-bold'>{t('whitepapers.info-graphic-title')}</p>
              </StyledLink>
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default BankingWhitepaper